module.exports = function() {
  return new Worker(__webpack_public_path__ + "2d4c8f05a3b6bfaf010d.worker.js");
};